export const TaskSlaGroupInfoTableTestIds = {
  TASK_SLA_GROUP_TABLE: 'task-sla-group.table',
};
